export enum WysiwygLinkType {
  url = 'LINK',
  email = 'EMAIL',
  tel = 'TEL',
}

export type LinkPortalController = {
  portalData: PortalData;
  setPortalData: (portalData: PortalData) => void;
};

export type PortalData =
  | {
      mode: 'create';
      rect: DOMRect;
      onClose: () => void;
      onSubmit: (link: string, type: WysiwygLinkType) => void;
    }
  | {
      mode: 'edit';
      rect: DOMRect;
      initialUrl: string;
      type: WysiwygLinkType;
      onClose: () => void;
      onSubmit: (link: string, type: WysiwygLinkType) => void;
      onDelete: () => void;
    }
  | null;
